import React, { useRef } from 'react';
import { CSVLink } from 'react-csv';
import './CsvTemplateDownloadCard.scss';

interface CsvTemplateDownloadCardProps {
  filename: string;
  columns: string[];
  exampleRow?: Record<string, string>;
}

const CsvTemplateDownloadCard = ({
  filename,
  columns,
  exampleRow,
}: CsvTemplateDownloadCardProps) => {
  const csvRef: React.RefObject<any> = useRef<any>(null);

  // Build headers in the shape react-csv expects
  const headers = columns.map((col) => ({ label: col, key: col }));

  /* Use the provided example row or fall back to an empty placeholder row
   * so the downloaded template always has at least one row to guide the user */
  const data: Record<string, string>[] = exampleRow
    ? [exampleRow]
    : [Object.fromEntries(columns.map((col: string) => [col, '']))];

  return (
    <div className="csv-template-card">
      <div className="csv-template-card-icon">
        <svg width="18" height="18" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M7.5 1C7.22386 1 7 1.22386 7 1.5V8.29289L5.35355 6.64645C5.15829 6.45118 4.84171 6.45118 4.64645 6.64645C4.45118 6.84171 4.45118 7.15829 4.64645 7.35355L7.14645 9.85355C7.34171 10.0488 7.65829 10.0488 7.85355 9.85355L10.3536 7.35355C10.5488 7.15829 10.5488 6.84171 10.3536 6.64645C10.1583 6.45118 9.84171 6.45118 9.64645 6.64645L8 8.29289V1.5C8 1.22386 7.77614 1 7.5 1ZM2.5 10C2.22386 10 2 10.2239 2 10.5V12.5C2 12.7761 2.22386 13 2.5 13H12.5C12.7761 13 13 12.7761 13 12.5V10.5C13 10.2239 12.7761 10 12.5 10C12.2239 10 12 10.2239 12 10.5V12H3V10.5C3 10.2239 2.77614 10 2.5 10Z"
            fill="currentColor"
            fillRule="evenodd"
            clipRule="evenodd"
          />
        </svg>
      </div>
      <div className="csv-template-card-content">
        <div className="csv-template-card-label">Need a template?</div>
        <div className="csv-template-card-description">
          Download a pre-formatted CSV with all the required columns ready to fill in.
        </div>
      </div>
      <button
        className="csv-template-card-button"
        onClick={() => csvRef.current?.link?.click()}
        type="button"
      >
        Download Template
      </button>
      <div style={{ display: 'none' }}>
        <CSVLink
          ref={csvRef}
          headers={headers}
          data={data}
          filename={filename}
          target="_blank"
        />
      </div>
    </div>
  );
};

export default CsvTemplateDownloadCard;